import { useEffect, useRef, useState } from "react";
import UseSentMutation from "../api/mutation/useSentMutation";

import SidebarOpen from "../assest/svg/sidebar_open.svg";
import { Sidebar } from "../components/common/Sidebar";
import { useAllChatsQuery } from "../api/query/useAllChatsQuery";
import { ChatType } from "../api/types/allChatType";
import { useChatByIdQuery } from "../api/query/useChatByIdQuery";
import { useCreateOrFetchUserMutation } from "../api/mutation/useCreateOrFetchUserMutation";
import { Input } from "../components/common/Input";
import { toast } from "react-toastify";
import { ChatBox } from "../components/common/ChatBox";
import DefaultPrompt from "../components/common/defaultPrompt";
import { useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useCreateThredMutaion } from "../api/mutation/useCreateThredMutaion";
import Loader from "../assest/loader.svg";
export type Message = {
  role: string;
  conversation_id: string;
  timestamp: string;
  content: string;
  image_urls: any[];
  id: string;
};

const ChatUI = ({
  isBubble,
  parentUrl,
}: {
  isBubble: boolean | undefined;
  parentUrl: string;
}) => {
  const [cancleStream, setCancleStream] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [tempId, setTempId] = useState("");
  const [messages, setMessages] = useState<Message[]>([]);
  const [firstMessage, setFirstMessage] = useState<ChatType[]>([]);
  const [input, setInput] = useState("");
  const [image, setImage] = useState<File[]>([]);
  const [userID, setUserID] = useState<string>("");
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(
    isBubble ? false : true
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedMessageThreadId, setSelectedMessageThreadId] =
    useState<string>("");
  const getChatQuery = useChatByIdQuery(
    selectedMessageThreadId ?? "",
    Boolean(selectedMessageThreadId)
  );
  const fetchAllChat = useAllChatsQuery(localStorage.getItem("user_id"));
  const getChats = fetchAllChat.data?.data.data;

  const handleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const updateThreadId = (thread_id: string) => {
    setSelectedMessageThreadId(thread_id);
    setSearchParams({ thread_id });
  };
  const useCreateThredMutaionQuary = useCreateThredMutaion();
  const setThred = () => {
    useCreateThredMutaionQuary.mutate(undefined, {
      onSuccess(data) {
        setSelectedMessageThreadId(data.data.thread_id);
        localStorage.setItem("thread_id", data.data.thread_id);
      },
      onError(error) {
        console.log(error);
      },
    });
  };
  const handleNewChat = () => {
    setMessages([]);
    setSearchParams({});
    setSelectedMessageThreadId("");
  };
  useEffect(() => {
    setSelectedMessageThreadId(searchParams.get("thread_id") ?? "");
  }, [searchParams]);

  useEffect(() => {
    if (!localStorage.getItem("thread_id") && !selectedMessageThreadId) {
      setThred();
    }
    if (!selectedMessageThreadId) {
      setSelectedMessageThreadId(localStorage.getItem("thread_id")??"");
    }
  }, [selectedMessageThreadId]);

  const handleMessage = (message: string) => {
    if (loading) {
      setLoading(false);
    }
    setFetching(true);

    setMessages((prevMessages) => {
      const updatedMessages = prevMessages.map((msg) =>
        msg.id === tempId ? { ...msg, content: msg.content + message } : msg
      );
      if (!updatedMessages.some((msg) => msg.id === tempId)) {
        updatedMessages.push({
          content: message,
          role: "system",
          conversation_id: "",
          timestamp: "",
          id: tempId,
          image_urls: [],
        });
      }

      return updatedMessages;
    });
  };

  const handleError = (error: any) => {
    console.log("Streaming Error:", error);
    toast.error(error.detail);
    setLoading(false);
    setFetching(false);
  };

  const mutation = UseSentMutation(
    handleMessage,
    handleError,
    cancleStream,
    setCancleStream
  );
console.log({selectedMessageThreadId});

  const handleSend = (prompt?: string) => {
    setTempId(uuidv4());
    setLoading(true);
    if ((prompt && prompt.trim()) || image.length || input.trim()) {
      const formData = new FormData();
      if (image) {
        const imageArray = Array.from(image);
        for (let img of imageArray) {
          formData.append("images", img);
        }
      }
      formData.append("prompt", input ? input : prompt || " ");
      formData.append("user_id", userID || "");
      formData.append(
        "source_url",
        Boolean(parentUrl) ? parentUrl : window.location.href
      );
      if (selectedMessageThreadId) {
        formData.append("thread_id", selectedMessageThreadId || "");
      }
      mutation.mutate(formData, {
        onSuccess() {
          setFetching(false);
          fetchAllChat.refetch().then((res) => {
            setFirstMessage(
              res.data?.data.data.sort(
                (a, b) =>
                  new Date(b.timestamp).getTime() -
                  new Date(a.timestamp).getTime()
              ) ?? []
            );
          });
          setLoading(false);
        },
        onError(error) {
          toast.error(error.response.data.detail);
          console.log("Mutation error:", error);
          setLoading(false);
          setFetching(false);
        },
      });

      // Reset input and add user message to the list
      setMessages([
        ...messages,
        {
          content: prompt ? prompt : input,
          role: "user",
          conversation_id: "",
          timestamp: "",
          id: "",
          image_urls: image
            ? Array.from(image).map((i) => URL.createObjectURL(i))
            : [],
        },
      ]);
      if (localStorage.getItem("thread_id") == selectedMessageThreadId) {
        localStorage.removeItem("thread_id");
      }
      setInput("");
      setImage([]);
    }
  };

  useEffect(() => {
    if (getChatQuery.data?.data.data && getChatQuery.data?.data.data.length) {
      setMessages(getChatQuery.data?.data.data ?? []);
    }
    if (isBubble) {
      setIsSidebarOpen(false);
    }
  }, [getChatQuery.data?.data.data, selectedMessageThreadId]);

  useEffect(() => {
    setFirstMessage(
      getChats?.sort(
        (a, b) =>
          new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
      ) ?? []
    );
  }, [getChats]);

  const fetchUser = useCreateOrFetchUserMutation();

  useEffect(() => {
    const getUserID = localStorage.getItem("user_id");
    if (!getUserID) {
      fetchUser.mutate(undefined, {
        onSuccess: (data) => {
          const res = data.data.data;
          if (data) {
            console.log(res);
            setUserID(res.user_id);
            localStorage.setItem("user_id", res.user_id);
            fetchAllChat.refetch();
          }
        },
      });
    } else {
      setUserID(getUserID);
    }
  }, []);
  const chatBox = useRef<HTMLDivElement | null>(null);
  const cancelApi = () => {
    setCancleStream(true);
  };
  return (
    <div className="flex h-full w-full scroll relative ">
     {!selectedMessageThreadId && <div className="absolute top-0 left-0 h-full w-full z-50 bg-gray-100/50 dark:bg-gray-600/50 flex justify-center items-center">
        <img className="w-28 h-28 brightness-50 dark:brightness-75" alt="loader" src={Loader} />
      </div>}
      <div
        className={`h-full ${
          isSidebarOpen && !isBubble ? "min-w-[15%]" : "w-0"
        } ${
          isBubble && isSidebarOpen
            ? "w-full absolute top-0 left-0 rounded-xl"
            : "w-0 "
        }  transition-all duration-300 overflow-hidden bg-white dark:bg-zinc-900/90 z-30`}
      >
        <Sidebar
          messages={firstMessage}
          thread_id={selectedMessageThreadId}
          onClose={handleSidebar}
          selectedChatId={updateThreadId}
          newChat={handleNewChat}
          isBubble={isBubble ? isBubble : false}
        />
      </div>

      <div
        className={`h-full bg-white dark:bg-zinc-900/90  min-w-[85%] transition-all duration-300 ${
          isBubble ? "rounded-xl" : ""
        }`}
      >
        <div className={`h-full  w-full ${isBubble ? "p-2" : ""} `}>
          {!isSidebarOpen && (
            <button
              onClick={handleSidebar}
              className="p-2 w-[5%] flex justify-start items-center fixed top-2 left-2 z-20"
            >
              <div className="w-5 min-w-5">
                <img
                  className="w-full h-full align-middle dark:invert"
                  src={SidebarOpen}
                  alt=""
                />
              </div>
            </button>
          )}
          <div
            className={` flex flex-col mx-auto ${
              messages.length > 0 ? "h-full" : ""
            } rounded-lg pb-2 pt-5 justify-between overflow-hidden relative ${
              isBubble ? "!w-full" : "!w-[60%]"
            }`}
          >
            <div className="h-full grow overflow-auto" ref={chatBox}>
              {messages.length ? (
                <ChatBox
                  chatBox={chatBox}
                  key={selectedMessageThreadId}
                  messages={messages}
                />
              ) : !isBubble ? (
                <>
                  <div className="my-14">
                    <div className="text-center mb-4">
                      <h1 className="text-5xl font-bold dark:text-white ">
                        Continuum
                      </h1>
                      <p className="text-lg dark:text-white ">
                        Donnez un élan de réussite à vos projets
                      </p>
                    </div>
                  </div>
                  <DefaultPrompt onClick={handleSend} />
                </>
              ) : (
                ""
              )}
            </div>
            <div
              className={`transition-all duration-200 ease-in-out w-full h-fit mb-8 relative  ${
                messages.length > 0 ? "bottom-0" : "-bottom-10"
              }  left-1/2 transform -translate-x-1/2 -translate-y-3`}
            >
              {loading && (
                <div className="flex gap-2 items-center">
                  <svg height="40" width="40" className="loader ml-5">
                    <circle
                      className="dot"
                      cx="10"
                      cy="20"
                      r="3"
                      fill="#ebf3fe"
                    />
                    <circle
                      className="dot"
                      cx="20"
                      cy="20"
                      r="3"
                      fill="#ebf3fe"
                    />
                    <circle
                      className="dot"
                      cx="30"
                      cy="20"
                      r="3"
                      fill="#ebf3fe"
                    />
                  </svg>
                </div>
              )}
              <Input
                loading={mutation.isPending}
                onSubmit={handleSend}
                setInput={setInput}
                setImage={setImage}
                input={input}
                image={image}
                cancelApi={cancelApi}
                fetching={fetching}
              />
            </div>
          </div>
        </div>
      </div>
      {!isBubble && (
        <div className="fixed bottom-1 right-0 w-full flex justify-center items-center dark:bg-transparent  bg-slate-50 dark:bg-custom-dark-sidebars">
          <div className="text-xs dark:text-white text-gray-500">
            Continuum 1.0 : Powered by{" "}
            <a
              href="https://blog-gestion-de-projet.com/"
              target="_blank"
              className="text-blue-500"
              rel="noreferrer"
            >
              Blog Gestion de Projet
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatUI;
